import { render, staticRenderFns } from "./BaseToastTemplate.vue?vue&type=template&id=cbb3069a&scoped=true&"
import script from "./BaseToastTemplate.vue?vue&type=script&lang=ts&"
export * from "./BaseToastTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToastTemplate.vue?vue&type=style&index=0&id=cbb3069a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb3069a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb3069a')) {
      api.createRecord('cbb3069a', component.options)
    } else {
      api.reload('cbb3069a', component.options)
    }
    module.hot.accept("./BaseToastTemplate.vue?vue&type=template&id=cbb3069a&scoped=true&", function () {
      api.rerender('cbb3069a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/toast/BaseToastTemplate.vue"
export default component.exports